import useSWR from 'swr'
import { resolveUrl } from '../../api'
import { Playlist } from 'common/types'
import { getLogger } from '../../logger'
import { PageLoading } from '../Loading/Loading'
import { OverlayInfoText } from './OverlayInfo'
import { unwrapPlaylist } from '../../utils'
import { Player } from './Player'

const log = getLogger('playlist')

interface PlaylistPlayerProps {
  playlistId?: string
  playlistData?: Playlist
  isPreview?: boolean
}

export const PlaylistPlayer = ({ playlistId, playlistData, isPreview }: PlaylistPlayerProps) => {
  const { data: fetchedPlaylist, error } = useSWR<Playlist>(
    playlistData ? null : resolveUrl(`playlist/${playlistId}`, isPreview ? { preview: true } : {}),
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
    }
  )
  const playlist = playlistData || fetchedPlaylist

  // Only show error if we have no cached data to display
  if (error && !playlist) {
    return <OverlayInfoText text={error.message || 'Error loading playlist'} />
  }

  if (!playlist) return <PageLoading />

  log('Playlist:', playlist)

  const playables = unwrapPlaylist(playlist)

  return <Player playables={playables} />
}
